import { services } from '../../data/services';
import ServiceCard from '../common/ServiceCard';

function ServicesOverview() {
  return (
    <section className="services-overview" aria-label="Primary services">
      <div className="container">
        <div className="services-grid">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesOverview;
